<script>
    import Auth from "./helpers/Auth";
    import Messages from "./helpers/messages/Messages";
    import LoadingIcon from "./LoadingIcon.svelte";
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
    import {setupI18n, _} from "../lib/i18n";

    export let language = 'en-US';
    setupI18n({ withLocale: language });
    export let token = null;
    export let auth_endpoint = '/auth/';

    export let csrfKey = '_csrf';
    export let csrfValue = null;

    Messages.registerLanguageVersion(language);

    let password;

    let mainError = null;
    let passwordError = null;
    let passwordRed = false;
    let showPass = false;

    //$: email && checkFields();
    $: password && checkFields();

    function checkFields() {
        passwordRed = false;
        if (password && password.length < 6) {
            passwordRed = true;
        }
    }


    let loading = false;

    const auth = new Auth({
        auth_endpoint
    });

    let isLoading = false;
    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        passwordError = null;

        isLoading = true;
        try {
            const response = await auth.savePassword(password, token, csrfKey, csrfValue);
            if (response.status === 'ok') {
                window.location.href = '/auth/instashpion-login';
            }
        } catch (error) {
            if (error.response.data.errors) {
                if (error.response.data.errors.password) {
                    passwordError = error.response.message;
                }
            }
        }
        isLoading = true;
    }
</script>

<Header />

<section class="canvas">
    <div class="canvas__col">
        <!-- Восстановление пароля, новый пароль, шаг 3 -->
        <section class="new-password-block tail">
            <form class="auth-form" on:submit = {onSubmit}>
                <h2 class="new-password-block__title tail__title">{$_('changePasswordForm.title')}</h2>
                <p class="new-password-block__text tail__text">{$_('changePasswordForm.description')}</p>
                <div class="new-password-block__form-wrapper form">
                    <div class="relative_block">
                        {#if showPass}
                            <input type="text" class={`${passwordRed ? 'error' : ''}
                                general-input new-password-block__input`} placeholder={$_('changePasswordForm.newPasswordInputPlaceholder')}
                                   bind:value={password}/>
                        {:else}
                            <input type="password" class={`${passwordRed ? 'error' : ''}
                                general-input new-password-block__input`} placeholder={$_('changePasswordForm.newPasswordInputPlaceholder')}
                                   bind:value={password}/>
                        {/if}
                        <span on:click={() => {showPass = !showPass}} class="eye_pass">
                        {#if showPass}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 3L15 15" stroke="black" stroke-width="2" stroke-linecap="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.45176 4.36597C3.07891 5.27491 1.99401 6.58339 1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15C10.7255 15 12.3269 14.4703 13.6508 13.565L12.5673 12.4815C11.532 13.1271 10.3094 13.5 9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75071 8.69352C3.30705 7.33514 4.29303 6.19899 5.53922 5.45344L4.45176 4.36597ZM6.922 6.83622C6.35371 7.38212 6 8.14975 6 9C6 10.6569 7.34315 12 9 12C9.85025 12 10.6179 11.6463 11.1638 11.078L10.1027 10.0169C9.82862 10.314 9.43604 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.56396 7.68605 8.17138 7.9831 7.89731L6.922 6.83622ZM11.9988 9.08462L8.91538 6.00117C8.94349 6.00039 8.9717 6 9 6C10.6569 6 12 7.34315 12 9C12 9.0283 11.9996 9.05651 11.9988 9.08462ZM14.0937 11.1795C14.5746 10.6269 14.9672 9.99527 15.2493 9.30648C15.3297 9.11022 15.3297 8.88978 15.2493 8.69352C14.2411 6.23185 11.8219 4.5 9 4.5C8.50822 4.5 8.02868 4.5526 7.5667 4.65249L6.34928 3.43507C7.18113 3.153 8.07263 3 9 3C12.4516 3 15.4064 5.11944 16.6374 8.12502C16.867 8.6856 16.867 9.31441 16.6374 9.87499C16.2794 10.7491 15.7756 11.5482 15.1562 12.242L14.0937 11.1795Z" fill="black" />
                            </svg>
                        {:else}
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.05667 9.59073L1.36262 9.87499L2.05667 9.59073ZM2.75072 8.69352C3.75892 6.23184 6.1781 4.5 9 4.5V3C5.54839 3 2.59359 5.11944 1.36262 8.12501L2.75072 8.69352ZM9 4.5C11.8219 4.5 14.2411 6.23185 15.2493 8.69352L16.6374 8.12502C15.4064 5.11944 12.4516 3 9 3V4.5ZM15.2493 9.30648C14.2411 11.7682 11.8219 13.5 9 13.5V15C12.4516 15 15.4064 12.8806 16.6374 9.87499L15.2493 9.30648ZM9 13.5C6.1781 13.5 3.75892 11.7682 2.75071 9.30648L1.36262 9.87499C2.59358 12.8806 5.54839 15 9 15V13.5ZM15.2493 8.69352C15.3297 8.88978 15.3297 9.11022 15.2493 9.30648L16.6374 9.87499C16.867 9.31441 16.867 8.6856 16.6374 8.12502L15.2493 8.69352ZM1.36262 8.12501C1.13303 8.68559 1.13303 9.31441 1.36262 9.87499L2.75071 9.30648C2.67033 9.11022 2.67033 8.88978 2.75072 8.69352L1.36262 8.12501Z"
                                      fill="black"/>
                                <circle cx="9" cy="9" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        {/if}
                    </span>
                    </div>
                    <button type="submit" class="button button_shadow new-password-block__btn" disabled={isLoading || !password || password.length < 6}>
                        <LoadingIcon show={isLoading} width="16" height="16" />
                        {$_('changePasswordForm.continueBtnLabel')}
                    </button>

                    {#if mainError}
                        <p class="new-password-block__form-error tail__error">{mainError}</p>
                    {/if}
                </div>
            </form>
        </section>
        <section class="new-password-block__additional">
            <a href="/auth/instashpion-login" class="button button_textual new-password-block__additional-btn">{$_('changePasswordForm.backBtnLabel')}</a>
        </section>
    </div>
</section>

<Footer {language} />

<style lang="scss">
  @import "style";

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/spy/logo.png) no-repeat center;
      width: 260px;
    }

    &.en-US {
      background: url(https://auth.datajam.pro/themes/spy/datajam-black-logo.png) no-repeat center;
      background-size: 100%;
      width: 170px;
    }
  }

  .relative_block {
    position: relative;
    margin-bottom: 12px;

    & input {
      width: 100%;
      margin: 0 0 16px !important;
    }
  }

  .eye_pass {
    position: absolute;
    right: 10px;
    top: 0;
    display: flex;
    align-items: center;
    height: 100%;
  }
</style>